import { FormControl } from '@angular/forms';

export const phoneNumberValidator = (control: FormControl) => {
  const valid = /^[0-9]{9}$/.test(control.value);

  if (control.value && !valid) {
    return {
      phoneNumber: false
    };
  }
  return null;
};
